import React from 'react';
import './Avatar.css';

export interface AvatarProps {
  avatarUrl: string;
  size: 'Small' | 'Medium' | 'Large' | 'X-Large';
  backgroundColor: string;
  username: string;
}
const Avatar = ({
  backgroundColor,
  avatarUrl,
  username,
  size,
  ...props
}: AvatarProps) => {
  if (avatarUrl !== '') {
    return (
      <img
        data-testid="avatar-test-id"
        src={avatarUrl}
        alt=""
        style={{ backgroundColor }}
        className={
          avatarUrl === '' && username === ''
            ? `avatar-image-${size} bg-[#E6E6E6] object-fill avatar-hover`
            : `loading-shimmer-${size}`
        }
      />
    );
  } else {
    return (
      <button
        data-testid="avatar-test-id"
        style={{ backgroundColor }}
        className={
          username !== ''
            ? `default-avatar-${size} justify-center rounded-[100px] bg-[#2e8b57] flex flex-row items-center text-[white] p-[10px] uppercase avatar-hover`
            : `loading-shimmer-${size}`
        }
      >
        {username[0]}
      </button>
    );
  }
};
export default Avatar;
